import { GlobalState } from '@lmt/unicorn-shared/app/store/types';

export const getTabs = (state: GlobalState) => state.navigation.tabs;
export const getDefaultTabs = (state: GlobalState) =>
  state.navigation.defaultTabs ?? [];
